import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Box, Button, TableCell, Typography } from "@mui/material";
import React from "react";

import AreaAPI from "../api/Area.api";
import BasicCreateModal from "../components/BasicCreateModal";
import Layout from "../components/Layout";
import ListModel from "../components/ListModel";
import { Area, TableColumn } from "../types";
import { extractDate } from "../utils";

const columns: TableColumn<Area>[] = [
  { field: "name", label: "Name" },
  { field: "createdAt", label: "Created At Date" },
];

function buildTableRow(area: Area): JSX.Element[] {
  return [
    <TableCell key={"name"}>{area.name}</TableCell>,
    <TableCell key={"createdAt"}>{extractDate(area.createdAt)}</TableCell>,
  ];
}

export default function AreaList() {
  const [openModel, setOpenModal] = React.useState<boolean>(false);
  return (
    <Layout>
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h2">Areas</Typography>
          <Button onClick={() => setOpenModal(true)}>
            <AddCircleIcon />
          </Button>
        </Box>

        <ListModel
          defaultOrderBy={"name"}
          modelApiUseList={AreaAPI.useList}
          modelBaseUrl={"areas"}
          columns={columns}
          buildTableRow={buildTableRow}
        />

        <BasicCreateModal
          open={openModel}
          onClose={() => setOpenModal(false)}
          modelApiUseSave={AreaAPI.useSave}
          navigateUrl="/areas"
        />
      </Box>
    </Layout>
  );
}
